<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-unordered-list`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 7h3A1.5 1.5 0 0110 8.5v3A1.5 1.5 0 018.5 13h-3A1.5 1.5 0 014 11.5v-3A1.5 1.5 0 015.5 7zm37.647 1H15.853C15.382 8 15 8.448 15 9v2c0 .552.382 1 .853 1h27.294c.471 0 .853-.448.853-1V9c0-.552-.382-1-.853-1zm0 14H15.853c-.471 0-.853.448-.853 1v2c0 .552.382 1 .853 1h27.294c.471 0 .853-.448.853-1v-2c0-.552-.382-1-.853-1zM15.853 36h27.294c.471 0 .853.448.853 1v2c0 .552-.382 1-.853 1H15.853c-.471 0-.853-.448-.853-1v-2c0-.552.382-1 .853-1zM8.5 21h-3A1.5 1.5 0 004 22.5v3A1.5 1.5 0 005.5 27h3a1.5 1.5 0 001.5-1.5v-3A1.5 1.5 0 008.5 21zm0 14h-3A1.5 1.5 0 004 36.5v3A1.5 1.5 0 005.5 41h3a1.5 1.5 0 001.5-1.5v-3A1.5 1.5 0 008.5 35z"/></svg>
</template>
<script>

export default {
  name: 'IconUnorderedList',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
